export default {"src":"/_next/static/media/graphic.01ac889a.svg","height":150,"width":328,"blurWidth":0,"blurHeight":0};